// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__EmL35","main":"AppShell_main__sRPM5"};